import type { SlideMasterProps } from '@features/powerpoint';
import { sectionHeaderBackgroundV2 } from '../../images';

export const SECTION_HEADER = '1_InMarket_Section Header';

export const sectionTitleSlideMasterV2: SlideMasterProps = {
  title: SECTION_HEADER,
  background: { path: sectionHeaderBackgroundV2 },
};
